import { NavBar } from "./components/navbar";
import { Header } from "./components/header";
import { MainContent } from "./components/mainContent";
import { Footer } from "./components/footer";






function App() {
  return (
    <>
    <NavBar/>
    <Header/>
    <MainContent/>
    <Footer/>
    </>
  );
}

export default App;
